import React from "react";
import Avatar from "react-avatar";

import { AWS_URL } from "../../config/config";
/**
 * @property {Image} image - the image to be displayed
 * @property {Boolean} isUrl - if the image is a path from AWS
 * @property {String} size - "Large", "Regular" - size of the image
 */
export default class ModamilyAppRoundImage extends React.Component {
  state = { ...this.props };

  shouldComponentUpdate = (nextProps) => {
    return nextProps.image === this.props.image;
  };

  render() {
    let { image, name, isUrl, draggableId } = this.state;

    if (this.props.image != null) {
      image = this.props.image;
    }

    let imgSizeClass = this.props.size ? this.props.size : "";
    if (draggableId) {
      return (
        <div
          id={draggableId}
          className={"roundImageContainer" + imgSizeClass}
          onClick={this.props.onClick ? this.props.onClick : null}
          style={{
            width: "100px",
            height: "100px",
            minWidth: "100px",
            minHeight: "100px",
            maxWidth: "100px",
            maxHeight: "100px",
            flexShrink: 0,
            flexGrow: 0
          }}
        >
          <Avatar
            className="roundImage"
            draggable="false"
            alt="loading"
            src={isUrl ? AWS_URL + image : image}
            name={name ? name : "Unknown"}
            round={true}
            size="100"
            textMarginRatio={0.15}
            textSizeRatio={3}
            unstyled={false}
            color={"#f07f46"}
            fgColor={"#4A2D4F"}
            style={{ 
              maxHeight: "100px",
              maxWidth: "100px",
              minHeight: "100px",
              minWidth: "100px",
              height: "100px",
              width: "100px",
              borderRadius: "50%",
              WebkitBorderRadius: "50%",
              MozBorderRadius: "50%",
              overflow: "hidden",
              flexShrink: 0,
              flexGrow: 0
            }}
          />
        </div>
      );
    } else {
      return (
        <div
          className={"roundImageContainer" + imgSizeClass}
          onClick={this.props.onClick ? this.props.onClick : null}
          style={{
            width: "100px",
            height: "100px",
            minWidth: "100px",
            minHeight: "100px",
            maxWidth: "100px",
            maxHeight: "100px",
            flexShrink: 0,
            flexGrow: 0
          }}
        >
          <Avatar
            className="roundImage"
            draggable="false"
            alt="loading"
            src={isUrl ? AWS_URL + image : image}
            name={name ? name : "Unknown"}
            round={true}
            size="100"
            textMarginRatio={0.15}
            textSizeRatio={3}
            unstyled={false}
            color={"#4A2D4F"}
            fgColor={"#4A2D4F"}
            style={{ 
              minHeight: "100px", 
              height: "100px", 
              maxHeight: "100px",
              minWidth: "100px",
              width: "100px",
              maxWidth: "100px",
              borderRadius: "50%",
              WebkitBorderRadius: "50%",
              MozBorderRadius: "50%",
              overflow: "hidden",
              flexShrink: 0,
              flexGrow: 0
            }}
          />
        </div>
      );
    }
  }
}
